import {actions} from "./actions";

export function getToggles(dispatch, globalDispatch) {
  return {
    setEventsTimelineList: payload => dispatch({ type: actions.SET_EVENTS_TIMELINE_LIST, payload: payload }),
    setIsLoading: payload => dispatch({ type: actions.SET_IS_LOADING, payload: payload }),
    setHasMore: payload => dispatch({ type: actions.SET_HAS_MORE, payload: payload }),
  }
}